<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="relative bg-gray-50">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-gray-300" />
        </div>
        <div class="relative flex justify-center">
      <span class="bg-white px-2 text-gray-500 bg-gray-50">
        <PlusIcon class="h-5 w-5 text-gray-500" aria-hidden="true" />
      </span>
        </div>
    </div>
    <div class="bg-gray-50">
        <div class="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
            <div class="max-w-3xl mx-auto divide-y-2 divide-gray-200">
                <h2 class="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">{{translate('headline')}}</h2>
                <dl class="mt-6 space-y-6 divide-y divide-gray-200">
                    <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">
                        <dt class="text-lg">
                            <DisclosureButton class="text-left w-full flex justify-between items-start text-gray-400">
                <span class="font-medium text-gray-900">
                  {{ faq.question }}
                </span>
                                <span class="ml-6 h-7 flex items-center">
                  <ChevronDownIcon :class="[open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform']" aria-hidden="true" />
                </span>
                            </DisclosureButton>
                        </dt>
                        <DisclosurePanel as="dd" class="mt-2 pr-12">
                            <p class="text-base text-gray-500">
                                {{ faq.answer }}
                            </p>
                        </DisclosurePanel>
                    </Disclosure>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronDownIcon, PlusIcon } from '@heroicons/vue/24/outline'
import translate from "./../../lang"

export default {
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ChevronDownIcon,
        PlusIcon
    },
    setup() {
        let faqs = [];
        let t = translate('faq');
        let i = 0;
        let key = 'items[' + i + '].';
        t('items').forEach((item) => {
            faqs.push({
                question: item.question,
                answer: item.answer,
            })
        });

        return {
            faqs,
            translate: t
        }
    },
}
</script>
